import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'datatypes',
    props: true,
    component: () => import('./page.vue'),
    meta: {
      middleware: [loggedIn]
    },
    children: [
      {
        path: ':id',
        name: 'datatypesTableComponent',
        props: true,
        component: () => import('./item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'datatypes' }
  }
];
